import { ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading, withRouterConfig } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import primeLocaleFileTradChinese from 'primelocale/zh-TW.json' with { type: 'json' };
import { setDefaultOptions } from 'date-fns';
import { zhTW } from 'date-fns/locale';
import { routes } from '@/app/app.routes';
import { authInterceptor } from '@/app/core/interceptors/auth-interceptor';
import { errorInterceptor } from '@/app/core/interceptors/error-interceptor';
import MainPreset from '@/app/shared/ui-kit/primeng/primeng-theme';

setDefaultOptions({ locale: zhTW });

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([errorInterceptor, authInterceptor]),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    providePrimeNG({
      ripple: true,
      overlayAppendTo: 'app-root',
      translation: primeLocaleFileTradChinese['zh-TW'],
      theme: {
        preset: MainPreset,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'components',
            order: 'reset, theme, base, components, utilities',
          },
        },
      },
      csp: {
        nonce: document.querySelector('app-root')?.getAttribute('ngCspNonce') ?? undefined,
      },
      pt: {
        button: {
          root: 'has-[.p-button-icon-only]:h-(--p-button-icon-only-width)',
        },
        datepicker: {
          decade: 'text-nowrap',
        },
        paginator: {
          root: 'justify-end',
          first: 'h-auto min-w-[calc(2rem+2px)] rounded-sm px-(--p-button-padding-x) py-(--p-button-padding-y) leading-[1.5]',
          prev: 'h-auto min-w-[calc(2rem+2px)] rounded-sm px-(--p-button-padding-x) py-(--p-button-padding-y) leading-[1.5]',
          page: 'h-auto min-w-[calc(2rem+2px)] rounded-sm px-(--p-button-padding-x) py-(--p-button-padding-y) leading-[1.5] border border-(--p-paginator-nav-button-background)',
          next: 'h-auto min-w-[calc(2rem+2px)] rounded-sm px-(--p-button-padding-x) py-(--p-button-padding-y) leading-[1.5]',
          last: 'h-auto min-w-[calc(2rem+2px)] rounded-sm px-(--p-button-padding-x) py-(--p-button-padding-y) leading-[1.5] border border-(--p-paginator-nav-button-background)',
        },
        tag: {
          root: 'text-xs',
          label: 'text-nowrap',
        },
        toggleSwitch: {
          handle: '-mt-2 h-4 rounded-full',
        },
      },
    }),
    ConfirmationService,
    MessageService,
  ],
};
